interface IConfigScheme {
	URL_API: string;
	URL_FORM: string;
	name: string;
}

const DEFAULT_URL_API = "https://cardpartner.net/api/v2/";
// The placeholder is replaced with the real API base URL by the Deployer.
// Builds that skip the Deployer (dev, Android via Capacitor) keep it as is
const DEPLOYED_URL_API = "_{{HOST_API}}_";

const resolveLiveUrlApi = (): string => {
	if (DEPLOYED_URL_API.startsWith("_{{")) return DEFAULT_URL_API;
	try {
		const url = new URL(DEPLOYED_URL_API).href;
		// Endpoints are appended to URL_API as is, so it must end with a slash
		return url.endsWith("/") ? url : url + "/";
	} catch (e) {
		console.error(`Invalid API host: ${DEPLOYED_URL_API}`, e);
		return DEFAULT_URL_API;
	}
};

const live: IConfigScheme = {
	// URL_API: "https://cabinet.impaya.com/api/v2/",
	URL_API: resolveLiveUrlApi(),
	URL_FORM: "https://cabinet.impaya.com",
	name: "live",
};

const local: IConfigScheme = {
	URL_API: DEFAULT_URL_API,
	URL_FORM: "https://cabinet.impaya.com",
	name: "local",
};

class Config {
	static storageVersion: number = 1;
	static scheme: IConfigScheme = process.env.NODE_ENV === "development" ? local : live;
	static version: string = "0.1.7";
	static MOCK_MODE: boolean = false;
}

export default Config;
